import { buildAccountPath, buildEventPath } from "./workspaceRoutes";
import type { EventCollectionId } from "./collectionIds";

export function buildAbsoluteAdminUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${window.location.origin}${normalized}`;
}

export function buildAccountAdminUrl(accountId: string): string {
  return buildAbsoluteAdminUrl(buildAccountPath(accountId));
}

export function buildEventAdminUrl(id: EventCollectionId): string {
  return buildAbsoluteAdminUrl(buildEventPath(id));
}

export async function copyTextToClipboard(text: string): Promise<boolean> {
  if (!text) {
    return false;
  }
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}
